<template>
    <component-wrapper-with-add-button
            v-model="internalValue"
            v-bind="subcomponentData"
            v-on:input="emitValue"
            :auto-emit="autoEmit"
            :add-button-label="addButtonLabelFinal"
    ></component-wrapper-with-add-button>

</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            urls: {type: Object},
            multiple: {type: Boolean, default: false},
            value: {},
            labelProperty: {type: String, default: 'name'},
            addButtonLabel: {type: String, default: null},
            autoEmit: {type: Boolean, default: true}
        },
        data: function () {
            return {
                internalValue: null,
                addButtonLabelFinal: null,
            }
        },
        created() {
            if (this.addButtonLabel === null) {
                this.addButtonLabelFinal = this.icon('plus');
            } else {
                this.addButtonLabelFinal = this.addButtonLabel;
            }
            if (this.multiple) {
                this.internalValue = [];
            } else {
                this.internalValue = -1;
            }
            if (this.value) {
                this.internalValue = this.value;
            }
        },
        mounted() {
        },
        methods: {
            emitValue: function(payload) {
                if (!this.autoEmit) {
                    return;
                }
                this.$emit('input', payload);
            }
        },
        computed: {
            subcomponentData: function() {
                let result = {};
                result['subComponent'] = 'searchableSelect';
                result['defaultSubComponentProps'] = {
                    multiple: false,
                    respectDisabledAttribute: true,
                    labelProperty: this.labelProperty,
                    addButtonHTML: this.icon('plus')+this.translate('Hozzáadás'),
                    revertXOpening: false
                }
                result['subComponentValuesetProp'] = 'valueset';
                result['clearAfterAdding'] = false;
                result['formUrl'] = this.urls.formUrl;
                result['storeUrl'] = this.urls.storeUrl;
                result['fetchUrl'] = this.urls.fetchUrl;
                result['editUrl'] = this.urls.editUrl ?? null;
                result['updateUrl'] = this.urls.updateUrl ?? null;

                return result;
            }
        },
        watch: {
            value: function() {
                this.internalValue = this.value;
            }
        }

    }
</script>
